export default __webpack_public_path__ + "static/media/Group 18302.ec95d734.png";